import "./action-cell.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import { trashIcon } from "@tql/ui-components-react/kendo/svg-icons";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { edit_01, plusCircle } from "@tql/ui-components-react/untitled/icons";

import { useUpdateExcludeGuide } from "~/features/routing-guide/hooks/use-update-exclude-guide.ts";
import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type { RoutingGuideType } from "~/shared/schemas/routing-guide-schema";

type ActionCellProps = GridCustomCellProps & {
	onHandleOpenEditModal: (guide: RoutingGuideType) => void;
	onHandleDelete: (id: number) => void;
	isCustomerLayout?: boolean;
	activeCustomerId?: number;
	testId?: string;
};

export const RoutingGuideActionsCell = (props: ActionCellProps) => {
	const dataItem = props.dataItem as RoutingGuideType;
	const isExcluded = dataItem.isExcluded;
	const optOutAbility = props.isCustomerLayout === true && !!dataItem.isGlobal;
	const customerId = props.activeCustomerId;
	const { updateExcludeRoutingGuide } = useUpdateExcludeGuide();

	return (
		<GridTd data-testid={props.testId} tdProps={props.tdProps}>
			<div style={{ display: "flex", gap: "8px" }}>
				{!optOutAbility && (
					<Button
						aria-label={"Edit routing guide"}
						id={"routing-guide-edit-button"}
						onClick={() => {
							props.onHandleOpenEditModal(dataItem);
						}}
						onMouseDown={(e) => e.preventDefault()}
					>
						<SvgIcon icon={edit_01} size={"xlarge"} />
					</Button>
				)}
				<Button
					aria-label={"Delete routing guide"}
					id={"routing-guide-delete-button"}
					onClick={() => {
						if (optOutAbility) {
							updateExcludeRoutingGuide({
								routingGuide: { ...dataItem, isGlobal: true },
								customerId: customerId,
								isExcluded: !!isExcluded,
							});
							return;
						}
						props.onHandleDelete(dataItem.id);
					}}
					onMouseDown={(e) => e.preventDefault()}
				>
					<SvgIcon icon={isExcluded ? plusCircle : trashIcon} size={"xlarge"} />
				</Button>
			</div>
		</GridTd>
	);
};
